export enum SearchOrigin {
  FILTER_CHANGE = 'FILTER_CHANGE',
  EXTERNAL_ACTION = 'EXTERNAL_ACTION',
  RESET_OR_RELOAD = 'RESET_OR_RELOAD',
  LOAD_NEXT = 'LOAD_NEXT',
  LOAD_PREV = 'LOAD_PREV',
}
